/* eslint no-console: "off", quotes: "off" */
import { mapState, mapActions, mapMutations } from "vuex";
import ResumeGame from "@/components/home/modals/ResumeGame";
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import Maintenance from '@/components/home/modals/Maintenance';
import { GameTypesEnums, GameModesEnums } from '@/common/mixins/game';
import modals from '@/common/modals';

const NewGameMixin = {
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'checkCoreResponses',
    ]),
    playGame(gameType, gameMode = null) {
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.storeModalForHomePage(Maintenance);
          this.showHideModal();
        } else {
          this.checkIfGameToResumeExists().then(() => {
            console.log('this.gameInProgress in Home js:', this.gameInProgress);
            modals.hideGenericModal();
            if (this.gameInProgress) {
              console.log('showing resume game pop up in Home js...');
              this.storeModalForHomePage(ResumeGame);
              this.showHideModal();
            } else if (this.userDetails.availableGames === 0) {
              this.storeModalForHomePage(ZeroBalance);
              this.showHideModal();
            } else if (!Object.values(GameTypesEnums).includes(gameType) || !Object.values(GameModesEnums).includes(gameMode)) {
              this.storeModalForHomePage(Maintenance);
              this.showHideModal();
            } else {
              this.storeModalForHomePage(null);
              this.$router.push(`/searchingOpponent/${gameType}/${gameMode}`);
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
    showHideModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close, .modal-overlay,.btn_close, .overlay').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          /* eslint-enable */
          this.storeModalForHomePage(null);
        });
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
    ]),
  },
};

export default NewGameMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/home.js